import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { panLookUp } from "../../../../../redux/features/sharedResources/sharedResources";
import CommonToast from "../../../../_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";
import {
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import CommonLayout from "../../../../_utils/CommonLayout";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";

const CreateFieldForcePanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  setLookupNext,
  lookupNext,
  BenEnableNextButton,
  verifyPANisLoading,
  type,
  previousId,
  beneLookError,

  setPreviousBankNo,

  payload,
  setShowAccInfo,
}) => {
  const dispatch = useDispatch();

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  useEffect(() => {
    if (!beneLookData?.status) {
      if (
        !beneLookLoading &&
        !verifyPANisLoading &&
        beneLookError === true &&
        verifiedPan &&
        panNumber?.length === GlobalConfiguration.panLength
      ) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    }
  }, [
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
    verifiedPan,
    panNumber,
    beneLookData,
  ]);

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  useEffect(() => {
    if (beneLookData?.beneficiary_accounts?.length > 0) {
      const accounts = beneLookData?.beneficiary_accounts || [];

      const foundAccount =
        accounts?.find((val) => val?.type_of_account === "field_force") ||
        accounts?.find((val) => val?.type_of_account === "reimbursement") ||
        accounts?.find((val) => val?.type_of_account === "tds") ||
        accounts?.find((val) => val?.type_of_account === "beneficiary");

      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }
  }, [openAssociatePopup, beneLookData]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account archived successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[
              GlobalConfiguration.lengthCheckZero
            ][GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });

          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[
              GlobalConfiguration.lengthCheckZero
            ][GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  const isPanValid = verifiedPan === true;

  const isConfirmDisabled = !isPanValid;

  return (
    <div className="w-width-full ">
      <div className="px-padding-md lg:px-padding-base py-padding-md pb-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] z-z-index-base">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePanChange(e);
              }}
              panDetails={panDetails}
              type={type}
            />
          </div>

          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)] ${
              type === "switch_account"
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            {verifiedPan === true &&
              beneLookLoading === false &&
              verifyPANisLoading === false && (
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      verifiedPan === false ? "" : "animate-slideInFromRight"
                    }
                  >
                    {" "}
                    <ConfirmBtnAccCreation
                      type="pan"
                      status={beneLookData?.status}
                      lookupNext={type === "switch_account" ? true : lookupNext}
                      isButtonDisabled={
                        type === "switch_account" ? false : isConfirmDisabled
                      }
                      selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                      not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                      handleClick={() => {
                        if (isConfirmDisabled || type === "switch_account")
                          return;
                        setLookupNext(true);
                      }}
                    />
                  </div>
                </div>
              )}

            <ActiveInactiveAssociatePopup
              flow={
                verifiedPan === false
                  ? "hideAssociate"
                  : verifiedPan === null ||
                      beneLookLoading ||
                      verifyPANisLoading
                    ? "defaultPan"
                    : !beneLookLoading &&
                        !verifyPANisLoading &&
                        beneLookError === true &&
                        verifiedPan &&
                        panNumber?.length === GlobalConfiguration.panLength
                      ? "notFoundPan"
                      : "Pan"
              }
              dropDownNo={GlobalConfiguration?.lengthCheckTwo}
              pan={payload?.panNumber}
              accActiveInactiveState={accActiveInactiveState}
              setAccActiveInactiveState={setAccActiveInactiveState}
              currentAssociate={currentAssociate}
              setCurrentAssociate={setCurrentAssociate}
              openAssociatePopup={openAssociatePopup}
              setOpenAssociatePopup={setOpenAssociatePopup}
              panLength={panNumber.length}
            />
          </div>
        </CommonLayout>
      </div>
    </div>
  );
};
export default CreateFieldForcePanDetails;
